exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-ai-robot-comment-item[data-v-1cb4567a]{display:flex;align-items:center}.maxwidth200[data-v-1cb4567a]{max-width:200px}.maxwidth300[data-v-1cb4567a]{max-width:300px}\n", ""]);

